import * as React from "react";
import Svg, { Path } from "react-native-svg";
import { forwardRef } from "react";
const SvgWater = (props, ref) => /* @__PURE__ */ React.createElement(Svg, { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: 1.5, strokeLinecap: "round", ref, ...props }, /* @__PURE__ */ React.createElement(Path, { d: "M3.41 1.5 L6.27 22.5 L17.73 22.5 L20.59 1.5", strokeLinecap: "round", stroke: "currentColor", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgWater);
export default ForwardRef;
